// Core
import { useTranslation } from 'react-i18next';

export const Translate = ({ label }) => {
  const { t } = useTranslation();
  var labelTranslation = label?.labelTranslations?.find(lt => lt.language.cultureString === t('locale'));

  if (labelTranslation) return labelTranslation.text;

  return label?.text ?? '';
};

export const translate = ({ label, t, languageCode }) => {
  var labelTranslation = label?.labelTranslations.find(lt => lt.language.cultureString === (languageCode || t('locale')));

  if (labelTranslation) return labelTranslation.text;

  return label?.text ?? '';
};

export const translateDropdown = (labels, t) => {
  var labelTranslation = labels?.find(lt => lt.language === t('locale'));

  if (labelTranslation) return labelTranslation.label;

  return '';
};

export default Translate;
